module.exports = __webpack_public_path__ + "html/studio-header_a7392320895a575ee004ec941ce9ac7c.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/studio-header.html
// module id = 1aEF
// module chunks = 154